import { forwardRef } from "react";
import { InputLabel, InputProps } from "..";
import { ValidatedInputGroup } from "./ValidatedInputGroup";

type SliderInputProps = InputProps & {
    min?: number;
    max?: number;
    step?: number;
    unitLabel?: string;
};

export const SliderInput = forwardRef<HTMLInputElement, SliderInputProps>((props, ref) => {
    const { fieldName, validationError, validateModel, className = "w-full", onEnter, min = 0, max = 100, step = 1, value = min, onChange, ...inputProps } = props;

    return (
        <ValidatedInputGroup fieldName={fieldName} validate={validateModel} validationError={validationError}>
            {({ handleBlur }) => (
                <div className="flex flex-col gap-2">
                    {props.label && <InputLabel>{props.label}</InputLabel>}
                    <div className="flex items-center gap-4">
                        <input
                            type="range"
                            ref={ref}
                            min={min}
                            max={max}
                            step={step}
                            value={value}
                            onChange={onChange}
                            onBlur={handleBlur}
                            onKeyUp={async (e) => {
                                if (onEnter && e.key === "Enter") {
                                    await onEnter();
                                }
                            }}
                            className={`w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-brand-primary ${className}`}
                            {...inputProps}
                        />
                        <span className="text-sm font-medium min-w-[3rem] text-right text-gray-700 whitespace-nowrap">
                            {value} {props.unitLabel}
                        </span>
                    </div>
                    <div className="flex justify-between text-xs text-gray-500 me-14 pe-2">
                        <span>{min}</span>
                        <span>{max}</span>
                    </div>
                </div>
            )}
        </ValidatedInputGroup>
    );
});
